import icon from "../assets/a3.webp";
import img1 from "../assets/g1.webp";
import img2 from "../assets/g2.webp";
import img3 from "../assets/g3.webp";
import img4 from "../assets/g4.webp";
import img5 from "../assets/g5.webp";
import img6 from "../assets/g6.webp";
import img7 from "../assets/g7.webp";
import img8 from "../assets/g8.webp";
import img9 from "../assets/g9.webp";
import img10 from "../assets/g10.webp";
import img11 from "../assets/g11.webp";
import img12 from "../assets/g12.webp";
import img13 from "../assets/g13.webp";
import img14 from "../assets/g14.webp";
import img15 from "../assets/g15.webp";
import port1 from "../assets/port1.webp";
import port2 from "../assets/port2.webp";
import port3 from "../assets/port3.webp";
import crane1 from "../assets/crane1.webp";
import crane2 from "../assets/crane2.webp";
import crane3 from "../assets/crane3.webp";
import crane4 from "../assets/crane4.webp";
import crane5 from "../assets/crane5.webp";
import crane6 from "../assets/crane6.webp";
import crane7 from "../assets/crane7.webp";
import crane8 from "../assets/crane8.webp";
import crane9 from "../assets/crane9.webp";
import crane10 from "../assets/crane10.webp";
import crane11 from "../assets/crane11.webp";
import crane12 from "../assets/crane12.webp";
import t1 from "../assets/t1.webp";
import t2 from "../assets/t2.webp";
import t3 from "../assets/t3.webp";
import yard1 from "../assets/yard1.webp";
import yard2 from "../assets/yard2.webp";
import yard3 from "../assets/yard3.webp";
import steve1 from "../assets/steve1.webp";
import steve2 from "../assets/steve2.webp";
import steve3 from "../assets/steve3.webp";
import steve4 from "../assets/steve4.webp";
import steve5 from "../assets/steve5.webp";
import steve6 from "../assets/steve6.webp";
import steve7 from "../assets/steve7.webp";
import steve8 from "../assets/steve8.webp";
import steve9 from "../assets/steve9.webp";
import steve10 from "../assets/steve10.webp";
import steve11 from "../assets/steve11.webp";
import steve12 from "../assets/steve12.webp";
import steve13 from "../assets/steve13.webp";
import steve14 from "../assets/steve14.webp";
import steve15 from "../assets/steve15.webp";
import steve16 from "../assets/steve16.webp";
import steve17 from "../assets/steve17.webp";
import steve18 from "../assets/steve18.webp";
import steve19 from "../assets/steve19.webp";
import steve20 from "../assets/steve20.webp";
import steve21 from "../assets/steve21.webp";
import steve22 from "../assets/steve22.webp";
import bbicon1 from "../assets/bbicon1.webp";
import bbicon2 from "../assets/bbicon2.webp";
import bbicon3 from "../assets/bbicon3.webp";
import bbicon4 from "../assets/bbicon4.webp";
import roro1 from "../assets/roro1.webp";
import roro2 from "../assets/roro2.webp";
import roro3 from "../assets/roro3.webp";
import roro4 from "../assets/roro4.webp";
import roro5 from "../assets/roro5.webp";
import roro6 from "../assets/roro6.webp";
import va1 from "../assets/va1.webp";
import va2 from "../assets/va2.webp";
import va3 from "../assets/va3.webp";
import va4 from "../assets/va4.webp";
import cha1 from "../assets/cha1.webp";
import cha2 from "../assets/cha2.webp";
import cha3 from "../assets/cha3.webp";
import cha4 from "../assets/cha4.webp";
import ocean1 from "../assets/ocean1.webp";
import ocean2 from "../assets/ocean2.webp";
import ocean3 from "../assets/ocean3.webp";
import ocean4 from "../assets/ocean4.webp";
import ocean5 from "../assets/ocean5.webp";
import ocean6 from "../assets/ocean6.webp";
import air1 from "../assets/air1.webp";
import air2 from "../assets/air2.webp";
import air3 from "../assets/air3.webp";
import cranes1 from "../assets/cranes1.webp";
import cranes2 from "../assets/cranes2.webp";
import cranes3 from "../assets/cranes3.webp";
import oem1 from "../assets/oem1.webp";
import oem2 from "../assets/oem2.webp";
import oem3 from "../assets/oem3.webp";
import container1 from "../assets/container1.webp";
import container2 from "../assets/container2.webp";
import container3 from "../assets/container3.webp";
import liquid1 from "../assets/liquid1.png";
import liquid2 from "../assets/liquid2.png";
import liquid3 from "../assets/liquid3.png";
import liquid4 from "../assets/liquid4.png";
import cfs1 from "../assets/cfs1.png";
import cfs2 from "../assets/cfs2.png";
import cfs3 from "../assets/cfs3.png";
const servicesData = {
  breakBulk: {
    title: (<>Breakbulk & Project <br />Cargo Handling</>),
    description: (
      <><strong>Breakbulk & Project Cargo Solutions That Redefine Logistics.</strong> At Success Shipping, we are<br /> specialists in handling<strong> oversized, heavy-lift, and non-containerized cargo</strong> that doesn’t fit into<br /> standard shipping containers. With close to 30 years of expertise and a proven record of<br /> <strong>15,000+ mafi trailer operations,</strong> we design and execute <strong>custom-engineered logistics solutions</strong><br /> to ensure your complex cargo moves safely and on time. </>),
    icon: icon,
    sections: [
      {
        type: "images",
        images: [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15],
      },
      {
        type: "div",
        heading: "Our Approach",
        content1: (<><strong>Engineering + Precision + Execution.</strong><br />
          From initial planning to final delivery, we take a<strong> hands-on, problem-solving <br />approach</strong> to every breakbulk and project cargo shipment. We believe that<br /> every challenge is an opportunity to innovate.</>),
        content2: (<><strong>Case in Point – 35-Meter Windmill Blades.</strong><br />
          We were tasked with transporting 35-meter-long windmill blades via RoRo<br /> vessel a job that couldn't rely on cranes due to insufficient vertical clearance <br />inside the ship. The solution? We designed and fabricated a custom forklift<br /> lifting bracket directly on the transport frame of the blades, right inside<br /> Ennore Port. Using<strong> tandem forklifts,</strong> we lifted and flawlessly loaded all three<br /> blades onto the vessel deck <strong>bypassing constraints and exceeding<br /> expectations.</strong></>),
      },
      {
        type: "cards",
        heading: "Our Breakbulk Strengths",
        cards: [
          {
            icon: bbicon1,
            title: "End-to-End Execution",
            text: "Planning, vessel booking, stowage design, and door-to-door delivery.",
          },
          {
            icon: bbicon3,
            title: "Lashing & Lifting Expertise",
            text: "Customized calculations for every unique cargo.",
          },
          {
            icon: bbicon4,
            title: "Safety-First Protocols",
            text: "Rigid SOPs to ensure zero damage and maximum efficiency.",
          },
          {
            icon: bbicon2,
            title: "Mafi Trailer Handling",
            text: "Decades of experience in moving heavy and irregular cargo using mafi trailers.",
          },
        ],
      },
      {
        type: 'why_choose_us',
        heading: "Why Choose Us?",
        description: (
          <>We blend <strong>engineering, innovation, and customer-centricity </strong>to deliver world-class breakbulk <br />solutions. Whether it’s machinery, industrial components, or renewable energy equipment, <strong>we <br />treat every shipment like it’s our own.</strong> </>),
      },
    ],

    descriptionSection: {
      heading: "Why Choose Us?",
      description: (
        <>We blend <strong>engineering, innovation, and customer-centricity </strong>to deliver world-class breakbulk <br />solutions. Whether it’s machinery, industrial components, or renewable energy equipment, <strong>we <br />treat every shipment like it’s our own.</strong> </>),
    },
  },

  roro: {
    title: "RORO Vessel Operations",
    description:
      (<><strong>RORO Operations Backed by 6 Million+ Vehicle Moves.</strong> For nearly three decades, <strong>Success<br /> Shipping has been the trusted partner for rolling cargo operations</strong> across India’s major ports.<br /> Our<strong> RORO expertise</strong> spans the movement of passenger cars, construction equipment, trucks,<br /> buses, and heavy machinery executed with <strong>unmatched speed and safety standards.</strong> </>),
    sections: [
      {
        type: "cards",
        heading: "Our Achievements",
        cards: [
          {
            icon: roro1,
            title: "6 Million+ Cars Handled",
            text: "Setting benchmarks in RORO logistics.",
          },
          {
            icon: roro2,
            title: "Record-Breaking Efficiency",
            text: (<>Successfully loaded <strong>3,338 cars in 8 hours,</strong> with a sustained <strong>average of 200 cars/hour.</strong></>),
          },
          {
            icon: roro3,
            title: "Tugmaster Precision",
            text: "Highly skilled operators ensure seamless mafi trailer and rolling stock movement.",
          },
        ],
      },
      {
        type: "cards",
        heading: "Why We Excel in RORO Operations",
        cards: [
          {
            icon: roro4,
            title: "Yard-to-Vessel Coordination",
            text: (<>We synchronize every step to <strong>reduce vessel turnaround times.</strong></>),
          },
          {
            icon: roro5,
            title: "Advanced Planning",
            text: "Optimized load plans that ensure maximum efficiency and minimal risk.",
          },
          {
            icon: roro6,
            title: "Experienced Team",
            text: "Specialists in handling all forms of rolling cargo — from passenger vehicles to ODC (Over-Dimensional Cargo).",
          },
        ],
      },
    ],
    heading: "What We Offer",
    icon: icon,
    highlights: [
      { text: "Loading and discharge planning for RORO vessels." },
      { text: "Mafi trailer handling for high-tonnage rolling stock." },
      { text: "Integrated solutions combining yard management and customs clearance." }
    ],
    descriptionSection: {
      heading: (<> Your Rolling Cargo, <br />Our Precision </>),
      description:
        (<>When it comes to RORO,<strong> precision, timing, and safety</strong> are everything. At Success Shipping,<strong> we deliver all three consistently.</strong></>),
    },
  },

  stevedoring: {
    title: "Stevedoring Services",
    description: (<><strong>Stevedoring You Can Trust.</strong> Our stevedoring operations are designed to <strong>maximize vessel <br />efficiency</strong> and <strong>ensure cargo safety.</strong> With expertise in <strong>RORO, Breakbulk, and ROCon vessels,<br /></strong> Success Shipping has built a reputation for <strong>precision-driven vessel handling.</strong><br /><br /><strong> Efficiency That Saves Time & Cost.</strong> Our team continuously optimizes processes to <strong>minimize<br /> vessel</strong> stay and reduce port costs for our clients. Through our <strong>Project Herby Initiative,</strong> we <br />analyze every operational bottleneck and implement real-time improvements<strong> delivering faster<br /> and smarter stevedoring.</strong> </>),
    sections: [
      {
        type: "images",
        images: [steve1, steve2, steve3, steve4, steve5, steve6, steve7, steve8, steve9, steve10, steve11, steve12, steve13, steve14, steve15, steve16, steve17, steve18, steve19, steve20, steve21, steve22],
      }
    ],
    heading: (<>Key Highlights of Our <br />Stevedoring</>),
    icon: icon,
    highlights: [
      {
        text: "Skilled manpower with years of RORO and breakbulk handling expertise.",
      },
      {
        text: "Advanced equipment such as tugmasters, forklifts, and heavy-lift cranes."

      },
      {
        text: "Precision in cargo stowage and discharge.",

      },
      {
        text: "24/7 coordination with port authorities for smooth operations.",

      },
    ],
    descriptionSection: {
      heading: "Why Partner With Us?",
      description:
        (<>We combine <strong>3 decades of experience,</strong> world-class equipment, and a <strong>safety-first approach</strong> to<br /> ensure your vessels are loaded and discharged <strong>efficiently, safely, and on time.</strong></>),
    },
  },

  vesselAgency: {
    title: "Vessel Agency",
    description: (<><strong>Your Reliable Port Partner.</strong> At Success Shipping, we offer <strong>comprehensive vessel agency<br /> services</strong> that cover every aspect of a vessel’s port call ensuring <strong>timely clearance, cost<br /> optimization, and hassle-free operations.</strong></>),
    sections: [
      {
        type: "cards",
        heading: "Our Port Agency Services Include",
        cards: [
          {
            icon: va1,
            title: "Husbandry",
            text: "Crew assistance, supplies, and port requirements.",
          },
          {
            icon: va2,
            title: "Crew Change",
            text: "Seamless coordination for crew disembarkation/embarkation.",
          },
          {
            icon: va3,
            title: "Cash-to-Master (CTM)",
            text: "Secure and efficient fund transfers for vessel operations.",
          },
          {
            icon: va4,
            title: "Specialized Vessels",
            text: (<>Handling <strong>IMDG Class 1 cargo</strong> (explosive materials such as bombs, shells, and grenades) with stringent safety protocols.</>),
          },
        ],
      },
    ],
    heading: "Why Success Shipping for Vessel Agency?",
    icon: icon,
    highlights: [
      { text: "Presence across Chennai, Ennore, Tuticorin, Karaikal, and all major Indian ports." },
      {
        text: "Decades of port experience ensures smooth coordination with authorities.",
      },
      {
        text: "24/7 operational support for ship masters and owners.",
      },
    ],
    descriptionSection: {
      description:
        (<>We act as your <strong>local eyes and ears at port,</strong> managing everything from documentation to last-mile needs <strong>so your vessel’s schedule is never compromised.</strong></>),
    },
  },

  customs: {
    title: "Customs Clearance (CHA)",
    description: (<><strong>Simplifying Customs, Maximizing Speed.</strong> Our <strong>Customs House Agent (CHA)</strong> division ensures<br /> <strong>fast and compliant clearance</strong> of every type of cargo from <strong>projects and breakbulk to bulk<br /> cargo and container exports.</strong> </>),
    sections: [
      {
        type: "cards",
        heading: "Our Expertise",
        cards: [
          {
            icon: cha1,
            title: "Project Imports (under licenses)",
            text: "Handled with technical documentation expertise.",
          },
          {
            icon: cha2,
            title: "Temporary Exports (ATA Carnet)",
            text: "Seamless solutions for goods that need to return.",
          },
          {
            icon: cha3,
            title: "Comprehensive Coverage",
            text: "Projects, breakbulk, bulk cargo, and containerized shipments.",
          },
          {
            icon: cha4,
            title: "Door-to-Door Solutions",
            text: "Documentation, customs liaison, and clearance — all under one roof.",
          },
        ],
      },
    ],
    heading: "Why Choose Us for Customs Clearance?",
    icon: icon,
    highlights: [
      { text: "Deep understanding of Indian customs regulations and documentation standards." },
      { text: "Dedicated team ensuring zero delays and smooth compliance" },
      { text: "Integrated with our transportation and port handling services for end-to-end cargo management.  " },
    ],
  },

  oceanFreight: {
    title: "Ocean Freight",
    description:
      (<><strong>Connecting Ports, Connecting the World.</strong> We offer <strong>comprehensive ocean freight forwarding<br /> services</strong> that connect Indian exporters and importers to <strong>global trade lanes </strong>through our trusted<br /> network of shipping partners. </>),
    sections: [
      {
        type: "cards",
        heading: "Our Ocean Freight Services Include",
        cards: [
          {
            icon: ocean1,
            title: "FCL & LCL",
            text: "FCL (Full Container Load) and LCL (Less-than-Container Load) solutions.",
          },
          {
            icon: ocean2,
            title: "Breakbulk & Heavy Lift Freight",
            text: "Breakbulk & Heavy Lift Freight for oversized cargo.",
          },
          {
            icon: ocean3,
            title: "Custom Freight Planning",
            text: "Cost-effective routes and schedules tailored to your needs.",
          },
        ],
      },
      {
        type: "cards",
        heading: "What Makes Us Different?",
        cards: [
          {
            icon: ocean4,
            title: "Global Carrier Partnerships",
            text: "Strong alliances with leading liners for priority bookings.",
          },
          {
            icon: ocean5,
            title: "Import & Export Expertise",
            text: "Covering major international trade hubs.",
          },
          {
            icon: ocean6,
            title: "End-to-End Integration",
            text: "Combined with our CHA, stuffing, and transportation services.",
          },
        ],
      },
    ],
  },

  airFreight: {
    title: "Air Freight",
    description: (<><strong>Speed and Precision Above All.</strong> When time is critical, our air <strong>freight solutions</strong> provide<strong> fast,<br /> reliable, and secure transport</strong> for both imports and exports.</>),
    sections: [
      {
        type: "cards",
        heading: "Air Freight Expertise",
        cards: [
          {
            icon: air1,
            title: "Priority Cargo Handling",
            text: "Time-sensitive shipments with guaranteed schedules.",
          },
          {
            icon: air2,
            title: "Door-to-Door Solutions",
            text: "Airport-to-warehouse delivery worldwide.",
          },
          {
            icon: air3,
            title: "Custom Clearance Integration",
            text: "Combined with our CHA expertise for smooth transitions.",
          },
        ],
      },
    ],
    heading: (<>Why Choose Our Air<br /> Freight?</>),
    icon: icon,
    highlights: [
      { text: "Partnerships with leading global carriers." },
      { text: "Real-time tracking for total shipment visibility." },
      { text: "Cost-effective options for express and consolidated air freight." }
    ],
  },

  cranes: {
    title: "Cranes & Equipment Supplies",
    description: (<><strong>Heavy Lifting, Simplified.</strong> We provide <strong>state-of-the-art cranes and cargo-handling equipment<br /></strong> to ensure <strong>safe and precise lifting operations</strong> for breakbulk, project cargo, and RORO vessels. </>),
    sections: [
      {
        type: "images",
        images: [crane1, crane2, crane3, crane4, crane5, crane6, crane7, crane8, crane9, crane10, crane11, crane12],
      },
      {
        type: "cards",
        heading: "Our Equipment Fleet",
        cards: [
          {
            icon: cranes1,
            title: "Mobile Cranes",
            text: "40 MT to 450 MT capacity.",
          },
          {
            icon: cranes2,
            title: "Mafi Tugmasters",
            text: "30 MT to 36 MT fifth wheel.",
          },
          {
            icon: cranes3,
            title: "Forklifts",
            text: "5 MT to 30 MT capacity.",
          },
        ],
      },
    ],
    heading: (<>Why Our Equipment<br /> Services?</>),
    icon: icon,
    highlights: [
      { text: "A strategically curated fleet of owned and partner-sourced equipment built for flexibility, availability, and scale." },
      { text: "Regularly maintained to international safety standards." },
      { text: "Operated by trained professionals with decades of cargo-handling experience." }
    ],
  },

  oem: {
    title: "OEM Port Management",
    description: (<><strong>Efficient Yard Management for High-Volume Cargo.</strong> We manage <strong>port operations for global<br /> manufacturers and energy companies,</strong> handling <strong>wind energy components, industrial goods,<br /> and high-volume shipments</strong> with precision.</>),
    sections: [
      {
        type: "cards",
        heading: "Our Port Management Services",
        cards: [
          {
            icon: oem1,
            title: "Real-Time Cargo Tracking",
            text: "Full visibility for every unit.",
          },
          {
            icon: oem2,
            title: "Seamless Dispatch",
            text: "Coordination between port, vessel, and factory.",
          },
          {
            icon: oem3,
            title: "Optimized Yard Space",
            text: "Reducing congestion and improving flow.",
          },
        ],
      },
    ],
  },

  container: {
    title: (<>Container and Mafi<br /> Stuffing & Lashing</>),
    description: (<><strong>Safety and Space Optimization at Its Best.</strong> Our <strong>container and Mafi (Roll-Trailer) stuffing and <br />lashing services</strong> ensure your cargo is <strong>securely fastened and optimized for space,</strong> minimizing <br />risks during transportation.</>),
    sections: [
      {
        type: "cards",
        heading: "What We Offer",
        cards: [
          {
            icon: container1,
            title: "Custom Lashing Design",
            text: "Pre-calculated plans for irregular cargo.",
          },
          {
            icon: container2,
            title: "Premium Lashing Materials",
            text: "Using woven belts, heavy-duty buckles, and timber chocks.",
          },
          {
            icon: container3,
            title: "Packaging Solutions",
            text: "Tailored to your cargo requirements.",
          },
        ],
      },
    ],
  },

  transportation: {
    title: "Transportation",
    description:
      (<><strong>Nationwide Movement, Simplified.</strong> Our <strong>transportation services</strong> cover <strong>Over-Dimensional Cargo (ODC),</strong> regular container movements, and <strong>last-mile deliveries,</strong> ensuring <strong>timely and safe cargo transfers.</strong></>),
    heading: (<>Why Our Transport Solutions<br /> Stand Out</>),
    sections: [
      {
        type: "images",
        images: [t1, t2, t3],
      }
    ],
    icon: icon,
    highlights: [
      { text: "Expertise in ODC logistics planning." },
      { text: "Modern fleet of trailers and trucks." },
      {
        text: "Door-to-door integration with customs and port services.",
      },
    ],
  },

  warehousing: {
    title: "Warehousing & Yard Management",
    description:
      (<><strong>Smart Storage for Modern Logistics.</strong> We provide <strong>general warehousing facilities</strong> combined<br /> with <strong>yard management expertise</strong> to ensure <strong>full cargo visibility and efficient space use.</strong></>),
    sections: [
      {
        type: "images",
        images: [yard1, yard2, yard3],
      }
    ],
    heading: "Key Features",
    icon: icon,
    highlights: [
      { text: "Real-time inventory tracking." },
      { text: "Space optimization strategies to reduce costs." },
      { text: "Exploring cold-chain storage for future expansion." },
    ],
  },

  comprehensive: {
    title: (<>Comprehensive Port<br /> Operations</>),
    description: (<><strong>Your Single-Window Logistics Partner. </strong>We offer<strong> comprehensive port operation services,</strong><br /> combining <strong>stevedoring, vessel agency, customs clearance, and yard management </strong>into a<br /> <strong>one-window solution.</strong> </>),
    sections: [
      {
        type: "images",
        images: [port1, port2, port3],
      }
    ],
    heading: "Why This Matters",
    icon: icon,
    highlights: [
      {
        text: "Eliminates the hassle of managing multiple vendors.",
      },
      {
        text: "Integrated Services One-stop solution for port operations.",
      },
      { text: "Trusted Partner Strong reputation in port logistics." },
    ],
  },
  LiquidBulk: {
    title: (<>Liquid Bulk – ISO Tank &<br /> Flexi Tank Container Handling</>),
    description: (<><strong>Safe, Compliant, and Precise Liquid Bulk Handling.</strong>
      At Success Shipping, <strong>we understand that liquid cargo requires  </strong>a different level of precision, safety, and regulatory compliance. <strong> That’s why we’ve built a specialized capability in handling </strong><br />ISO tank containers and flexi tank containers — catering to chemical, <strong> food-grade, and pharmaceutical logistics with zero margin for error</strong></>),
    sections: [
      {
        type: "cards",
        heading: "What We Offer",
        cards: [
          {
            icon: liquid1,
            title: "End-to-End Handling",
            text: "From vessel discharge to road dispatch or factory delivery.",
          },
          {
            icon: liquid2,
            title: "Specialized Equipment",
            text: "Lifting, grounding, and securing tanks with certified handling gear.",
          },
          {
            icon: liquid3,
            title: "Compliance-Driven",
            text: "Adhering strictly to hazardous and non-hazardous material protocols, including IMDG regulations.",
          },
          {
            icon: liquid4,
            title: "Condition Checks & Reporting",
            text: "Pressure checks, seals, temperature monitoring, and cleaning coordination (if required).",
          },
        ],
      },
    ],
    heading: "Why Choose Us for Liquid Bulk",
    icon: icon,
    highlights: [
      {
        text: "Trained personnel with tank-specific handling experience.",
      },
      {
        text: "Coordination with tank operators, surveyors, and labs for seamless flow.",
      },
      { text: "Safety-first SOPs to ensure zero leaks, zero delays, and full traceability." },
    ],
  },
  descriptionSection: {
    description:
      (<>Whether you're moving  <strong>high-grade chemicals or food-based liquids,</strong>  Success Shipping ensures your <strong>cargo is handled with the utmost precision and care.</strong></>),
  },
  CFS: {
    title: (<>CFS (Container Freight Station) <br /> Handling</>),
    description: (
      <>
        <strong>Where Container Operations Get Seamless.</strong>
        Our CFS handling solutions <strong>offer full-service import/export support</strong>
        for FCL and LCL cargo, combining speed, <strong>transparency, accuracy,</strong> and
        <strong> precise coordination with port terminals</strong> and customs authorities —
        ensuring <strong>a higher level of precision, safety,</strong> and regulatory compliance.
      </>
    ),

    sections: [
      {
        type: "cards",
        heading: "What We Handle",
        cards: [
          {
            icon: cfs1,
            title: "Import CFS Handling",
            text: "De-stuffing, cargo segregation, customs coordination, and last-mile dispatch.",
          },
          {
            icon: cfs2,
            title: "Export CFS Handling",
            text: "Receiving cargo, container stuffing, lashing, and documentation handoff.",
          },
          {
            icon: cfs3,
            title: "Real-Time Inventory",
            text: "Digital tracking of cargo movement for both inbound and outbound operations.",
          }
        ],
      },
    ],
    heading: "Why Our CFS Stands Out",
    icon: icon,
    highlights: [
      {
        text: "Integrated with port and customs systems for faster clearance.",
      },
      {
        text: "Equipped with trained staff, forklifts, and safety infrastructure.",
      },
      { text: "Dedicated team for time-sensitive and reefer cargo coordination." },
    ],
  },
  descriptionSection: {
    description:
      (<>Success Shipping’s CFS <strong>services are built for efficiency, accuracy, and dependability—ensuring  </strong>  your cargo moves through every checkpoint, right on time. </>),
  },
};

export default servicesData;


